// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_g2-a";
export var fulfillmentFormRail = "_g2-9";
export var headerTitleRow = "_g2-c";
export var orderDetailsWrapper = "_g2-7";
export var orderLinkTrigger = "_g2-2";
export var paymentInformationGrid = "_g2-h";
export var paymentSummaryColumn = "_g2-i";
export var shipmentContainer = "_g2-b";
export var shipmentDetailsMainPane = "_g2-8";
export var shipmentNavigationCard = "_g2-5";
export var shipmentNavigationRail = "_g2-3";
export var shipmentNavigationRailHeader = "_g2-4";
export var shipmentSummaryFact = "_g2-e";
export var shipmentSummaryGrid = "_g2-d";
export var shipmentSummaryMetadataRow = "_g2-f";
export var shipmentSummaryTags = "_g2-g";
export var shipmentWorkspace = "_g2-0";
export var shipmentWorkspaceContent = "_g2-6";
export var shipmentWorkspaceHeader = "_g2-1";